import Typography from "../../../components/Typography";
import Button from "../../../components/button";
import { FOLDER, PLUS } from "../../../assets";
import PieCharts from "../../../components/chart/Piechart";
import { TableComponent } from "../../../components/table/Table";
import {
  CASE_COLUMNS,
  CASE_FOLDER_COLUMNS,
} from "../../../components/table/columns";
import { useEffect, useState } from "react";
import { useGetCaseFoldersQuery } from "../../../services/apis/cases";
import CreateCases from "../components/create-cases";
import DropDown from "../../../components/dropdownBtn";
import { Box, Skeleton } from "@mui/material";
import Api from "../../../config";
import { getJSONheader } from "../../../utils";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/UI/modal";
import PaginatedTable from "../../../components/table/Paginated-table";
import { Transition } from "@headlessui/react";
import { FaEllipsisV } from "react-icons/fa";
import { toast } from "react-hot-toast";

function Dashboard() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const [completedCaseStat, setCompletedCaseStat] = useState("Year");
  const [ongoinCaseStat, setOngoinCaseStat] = useState("Year");

  const [summary, setSummary] = useState<any>({});
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [fileProcessModal, setFileProcessModal] = useState(false);
  const [fpSuitNo, setFpSuitNo] = useState("");
  const [fpResults, setFpResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Api.get(`/lawyer/case-folders`, getJSONheader());
      const { data, meta, summary } = response.data;
      setLoading(false);
      setData(data);
      if (summary) {
        setSummary(summary);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [data?.length]);

  return (
    <div className="pt-4 px-8">
      <Typography textStyle="text-[20px] font-medium">My Dashboard</Typography>
      <div className="w-full  pb-20 lg:pb-8">
        <div className="w-full flex flex-row justify-end items-start pl-5 pt-4 lg:pt-0">
          <Button
            icons={PLUS}
            iconClassName="h-[0.9rem] w-3"
            title="Create Case Folder"
            bgColor={"bg-[#13BAED]"}
            onClick={() => navigate("/non-lawyer/create-case")}
            hoverColor={""}
            textColor={"text-white"}
            className={"py-3"}
          />
          <div className="ml-3">
            <Button
              icons={""}
              iconClassName="h-[0.9rem]"
              title="File a Process"
              bgColor={"bg-[#272755]"}
              onClick={() => setFileProcessModal(true)}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3"}
            />
          </div>
        </div>
        <div className="w-full lg:flex justify-between items-center">
          <div className="w-full lg:w-[46%] p-8 mb-4 lg:mb-0 flex flex-col  lg:flex-row justify-between items-center shadow-widget rounded-lg">
            <div className="w-full lg:w-[46%] ">
              <Typography
                variant="label"
                textStyle="text-center lg:text-start lg:px-2  mb-2 lg:mb-0"
              >
                Total Cases Filed
              </Typography>
              <Typography textStyle="text-center lg:text-start px-2  mb-2 lg:mb-0 font-bold text-brand_indigo text-[44px]">
                {summary?.all_files || 0}
              </Typography>
              <div className="flex justify-center lg:justify-start items-center">
                <DropDown
                  {...{
                    state: completedCaseStat,
                    setState: setCompletedCaseStat,
                  }}
                />
              </div>
            </div>

            <div className="w-full lg:w-[48%] h-52">
              <div className=" w-full">
                <PieCharts />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-[46%] p-8 mb-4 lg:mb-0 flex flex-col  lg:flex-row justify-between items-center shadow-widget rounded-lg">
            <div className="w-full lg:w-[46%] ">
              <Typography
                variant="label"
                textStyle="text-center lg:text-start lg:px-2  mb-2 lg:mb-0"
              >
                On-going Cases
              </Typography>
              <Typography textStyle="text-center lg:text-start px-2  mb-2 lg:mb-0 font-bold text-brand_indigo text-[44px]">
                {summary?.on_going || 0}
              </Typography>

              <DropDown
                {...{ state: ongoinCaseStat, setState: setOngoinCaseStat }}
              />
            </div>

            <div className="w-full lg:w-[48%] h-52">
              <div className=" w-full">
                <PieCharts />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 lg:flex justify-between items-end">
          <div className=" w-full lg:mb-0">
            <div className=" border-b  border-[#F0F0F0] rounded-b-xl">
              {isLoading || data?.length > 0 ? (
                <TableComponent
                  DATA={data}
                  COLUMNS={CASE_COLUMNS}
                  TITLE="Recent Case Folders"
                  isExport={null}
                  isPaginated={null}
                  isSearch={null}
                  size={size}
                  setSize={setSize}
                  setPageIndex={(value: number) => page + 1}
                  className="rounded-none rounded-t-0"
                  isLoading={isLoading}
                />
              ) : !isLoading && data?.length < 1 ? (
                <div className="flex flex-col justify-center items-center h-52">
                  <img src={FOLDER} className="h-20" />
                  <p className="text-center text-xs">
                    No Case Folder available at the moment
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <CreateCases {...{ open, setOpen }} />
      <Modal
        maxWidth={"md"}
        open={fileProcessModal}
        close={() => setFileProcessModal(false)}
      >
        <div className="px-6 py-6">
          <span className="text-2xl font-semibold text-black">
            File a Process
          </span>
          <div className="mt-4">
            <span className="text-sm font-medium">Enter suit number</span>
            <input
              type="text"
              value={fpSuitNo}
              onChange={(e) => setFpSuitNo(e.target.value)}
              className="w-full px-3 border rounded border-[#CACACA] h-[50px] outline-none mt-2"
            />
            <div className="flex justify-end items-center mt-3">
              <Button
                iconClassName="h-[0.9rem] w-3"
                title="Search"
                isLoading={isSearching}
                bgColor={"bg-[#272755]"}
                onClick={async () => {
                  setIsSearching(true);
                  try {
                    const response = await Api.get(
                      `/lawyer/case-folders/suit-number?suit_number=${fpSuitNo}`,
                      getJSONheader(),
                    );
                    const { data } = response.data;
                    setFpResults(data ? [data] : []);
                  } catch (e) {
                    toast.error("Unable to fetch case folder");
                    setFpResults([]);
                  } finally {
                    setIsSearching(false);
                  }
                }}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-32"}
              />
            </div>
            {isSearching && (
              <div className="mt-2 text-sm text-gray-500">Searching…</div>
            )}
          </div>
          {!isSearching && fpResults.length > 0 && (
            <div className="mt-6">
              <PaginatedTable
                columns={[
                  {
                    Header: "S/No.",
                    Cell: ({ cell: { row } }: any) => (
                      <span className="text-xs">{Number(row.id) + 1}</span>
                    ),
                  },
                  { Header: "Suit no", accessor: "suit_number" },
                  { Header: "Case Title", accessor: "title" },
                  {
                    Header: "Action",
                    Cell: ({ cell: { row } }: any) => {
                      const navigate = useNavigate();
                      const [dropdown, setDropdown] = useState(false);
                      return (
                        <>
                          <FaEllipsisV
                            size={20}
                            color="#101828"
                            className="hover:bg-green-100 p-1 cursor-pointer rounded-md"
                            onClick={() => setDropdown((prev) => !prev)}
                          />
                          <Transition
                            as="div"
                            show={dropdown}
                            className="w-[170px] h-[70px] flex flex-col gap-y-2 items-start rounded-xl shadow-lg absolute right-20 z-[9999] bg-white mt-6 text-sm font-medium py-5"
                          >
                            <span
                              className="hover:bg-[#BFD0F2] w-full py-1 pl-3 cursor-pointer"
                              onClick={() => {
                                navigate(
                                  `/non-lawyer/file-a-process?id=${row?.original?.id}`,
                                );
                                setFileProcessModal(false);
                              }}
                            >
                              File a process
                            </span>
                          </Transition>
                        </>
                      );
                    },
                  },
                ]}
                data={fpResults}
                totalPages={1}
                fetchData={() => {}}
                isLoading={false}
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default Dashboard;
